import { render, staticRenderFns } from "./UserStatisticsTable.vue?vue&type=template&id=79cc571b&scoped=true"
import script from "./UserStatisticsTable.vue?vue&type=script&lang=js"
export * from "./UserStatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./UserStatisticsTable.vue?vue&type=style&index=0&id=79cc571b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc571b",
  null
  
)

export default component.exports